import { isEmpty, isNil } from 'lodash'

const isClear = (value) => isNil(value) || isEmpty(value)

export default isClear
